// RadarChart.js
import ReactECharts from "echarts-for-react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const MAX_VALUE = 105;

const GraphSangatiLeft = ({
  height = "280px",
  islightdisabled,
  showCompatibility,
  lightData = {},
  matcheelightdata = {},
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const UserLightData = islightdisabled
    ? [0, 0, 0, 0, 0, 0, 0, 0]
    : [
        lightData.extraversion || 0,
        lightData.agreeableness || 0,
        lightData.comfort_zone || 0,
        lightData.rule_abiding || 0,
        lightData.stability || 0,
        1000,
        1000,
        1000,
      ];

  const MatcheeLightData = [
    matcheelightdata.extraversion || 0,
    matcheelightdata.agreeableness || 0,
    matcheelightdata.comfort_zone || 0,
    matcheelightdata.rule_abiding || 0,
    matcheelightdata.stability || 0,
    1000,
    1000,
    1000,
  ];

  const option = {
    tooltip: { show: false },
    radar: {
      center: ["98.5%", "50%"],
      shape: "circle",
      splitArea: {
        show: false,
      },
      splitLine: {
        show: false,
      },
      axisLine: {
        lineStyle: {
          width: 3,
          color: "#93938D",
        },
      },
      radius: window.innerWidth < 768 ? "140%" : "80%",
      lineStyle: {
        color: "#ffffff",
      },
      name: {
        formatter: (name) => {
          if (name === t("extraversionShortForm")) {
            return `{ext|${name}}`;
          } else if (name === t("stabilityShortForm")) {
            return `{st|${name}}`;
          } else if (name === t("comfortZoneShortForm")) {
            return `{cz|${name}}`;
          } else if (name === t("ruleAbidingShortForm")) {
            return `{ra|${name}}`;
          } else if (name === t("agreeablenessShortForm")) {
            return `{ag|${name}}`;
          }
          return name;
        },
        rich: {
          ext: {
            padding: [0, 0, -10, -30],
            color: "#000",
            fontSize: 12,
          },
          st: {
            padding: [-10, 0, 0, -30],
            color: "#000",
            fontSize: 12,
          },
          cz: {
            padding: [5, -5, 0, 0],
            color: "#000",
            fontSize: 12,
          },
          ra: {
            padding: [0, -10, 0, 0],
            color: "#000",
            fontSize: 12,
          },
          ag: {
            padding: [0, -5, 0, 0],
            color: "#000",
            fontSize: 12,
          },
        },
        textStyle: {
          fontSize: 12,
          color: "#000",
        },
      },
      indicator: [
        { name: t("extraversionShortForm"), max: MAX_VALUE }, // "Ex"
        { name: t("agreeablenessShortForm"), max: MAX_VALUE }, // "Ag"
        { name: t("comfortZoneShortForm"), max: MAX_VALUE }, // "C.Z"
        { name: t("ruleAbidingShortForm"), max: MAX_VALUE }, // "R.A"
        { name: t("stabilityShortForm"), max: MAX_VALUE }, // "St"
        { name: "", max: MAX_VALUE },
        { name: "", max: MAX_VALUE },
        { name: "", max: MAX_VALUE },
      ],
    },
    series: [
      {
        type: "radar",
        lineStyle: {
          color: "#93938D",
        },
        data: [
          {
            value: UserLightData,
            // Users main graph style (dark pink, filled, opacity 0.95)
            areaStyle: { 
              color: "#561832", 
              opacity: 0.95
            },
            // Users circle style (blue, circle with black border)
            symbol: "circle",
            symbolSize: 4,
            itemStyle: {
              color: "#BEEDF3",
              borderColor: "#000000",
              borderWidth: 1,
            },
            emphasis: { disabled: true },
          },
          ...(showCompatibility && !islightdisabled
            ? [
                {
                  value: MatcheeLightData,
                  // Matchee main graph style (light pink, filled, opacity 0.70)
                  areaStyle: { color: "#1D304DB2", opacity: 0.70 },
                  // Matchee circle style (light pink, rect with black border)
                  symbol: "rect",
                  symbolSize: 4,
                  itemStyle: {
                    color: "#F2B8B8",
                    borderColor: "#000000",
                    borderWidth: 0.5,
                  },
                  emphasis: { disabled: true },
                },
              ]
            : []),
        ],
      },
    ],
  };

  return (
    <div className="relative h-full w-full overflow-hidden px-1"
      onClick={() => {
        if (!islightdisabled) {
          navigate("/graph-details-light", {
            state: { showCompatibility, UserLightData, MatcheeLightData },
          });
        }
      }}>
      <ReactECharts
        option={option}
        style={{ width: "100%", height: height }}
        notMerge={true}
        lazyUpdate={true}
      />
      <div
        className="absolute -bottom-1 left-3"
      >
        <img src="/icons/Sangati/leftarrow1.svg" alt="" className="w-8 h-8" />
      </div>
    </div>
  );
};

export default GraphSangatiLeft;
